// Components & Data Imports
import Photos from '../resources/imgs/photos.webp'

// Icons
import { FaBookOpen } from 'react-icons/fa'

const AboutUs = () => {
  return (
    <div className='about-container' id='about'>
      <div className='about-heading'>
        <FaBookOpen className='about-heading-icon' />
        <div className='about-heading-title'>Náš příběh</div>
        <div className='about-heading-subtitle'>
          Už 35 let vytváříme vzpomínky na celý život
        </div>
      </div>
      <div className='about-box'>
        <div className='about-box-left'>
          <img
            src={Photos}
            alt='Tábor Hlavas'
            className='about-box-left-photos'
          />
        </div>
        <div className='about-box-right'>
          <div className='about-box-right-info'>
            <span>Tábor s tradicí</span>
            <br />
            Když naši zakladatelé před lety odjížděli na první tábor, nejspíš
            netušili, že jejich nápad vydrží více než 35 let. Dnes je spolek
            Hlavas součástí tradice táborů Vodních staveb a místem, kde děti
            prožívají léta plná dobrodružství, kamarádství a společných zážitků.
            Každý ročník přináší nové příběhy, podporuje dětskou fantazii, chuť
            objevovat svět kolem sebe a hlavně dává vzniknout přátelstvím, na
            která se nezapomíná.
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutUs
